import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import GridContainer from "components/Grid/GridContainer"; // Custom Grid container component
import GridItem from "components/Grid/GridItem"; // Custom Grid item component
import { connect } from "react-redux";
import {
  loginRequest,
  setUserRole,
  setAppBarName,
  setLayoutName,
} from "../../../Redux/Actions/LoginActions"; // Redux actions for login
import styles from "../../../assets/jss/material-dashboard-react/views/LoginPage"; // Custom styles for the login page
import logo from "../../../assets/img/vikingstransparent_logo.png"; // Logo image

// Create custom styles using Material-UI's makeStyles
const useStyles = makeStyles(styles);

const InvalidURL = () => {
  const classes = useStyles(); // Initialize styles

  return (
    <div className={classes.container}>
      {/* Grid container for layout */}
      <GridContainer>
        <GridItem xs>
          <div className={classes.root}>
            {/* Display logo */}
            <img className={classes.logo} src={logo} alt="Viking Logo" />
            {/* Display error message */}
            <Typography color="textPrimary" variant="h4" gutterBottom>
              uh oh!
            </Typography>
            <Typography color="textPrimary" variant="body1" gutterBottom>
              It seems like you&apos;re trying an invalid URL. Please retry with a valid URL.
            </Typography>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
};

// Define prop types for the component
InvalidURL.propTypes = {
  history: PropTypes.object, // React Router history object for navigation
  prop: PropTypes.any, // Additional props (if any)
};

// Map Redux state to component props
const mapStateToProps = ({ app }) => ({
  userData: app.userDetails, // Map user details from Redux state
});

// Connect component to Redux and export
export default connect(mapStateToProps, {
  loginRequest, // Redux action to handle login requests
  setUserRole, // Redux action to set user role
  setAppBarName, // Redux action to set app bar name
  setLayoutName, // Redux action to set layout name
})(InvalidURL);
